import React from 'react';
import { motion } from "framer-motion";
import './Testimonials.css';

function Testimonials() {
  const reviews = [
    {
      name: "Alex Rivera",
      role: "Corporate Lawyer",
      text: "This AI saved me hours every week. The insights are incredibly accurate and the risk detection is second to none.",
      stars: 5
    },
    {
      name: "Sarah Jenkins",
      role: "Startup Founder",
      text: "We use it daily for NDAs and contracts — it’s a game changer for a fast-growing company like ours.",
      stars: 5
    },
    {
      name: "David Chen",
      role: "Legal Consultant",
      text: "Fantastic interface and excellent customer support. It bridge the gap between technology and traditional law perfectly.",
      stars: 5
    },
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.2, delayChildren: 0.3 }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, scale: 0.9, y: 20 },
    visible: { 
      opacity: 1, 
      scale: 1, 
      y: 0, 
      transition: { duration: 0.5, ease: "easeOut" } 
    }
  };

  return (
    <section id="testimonials" className="legal-testimonials-section">
      <div className="legal-testimonials-container">
        <motion.div 
          className="legal-testimonials-header"
          initial={{ opacity: 0, y: -20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <span className="legal-testimonials-badge">Client Reviews</span>
          <h2 className="legal-testimonials-title">What Our Clients Say</h2>
        </motion.div>

        <motion.div 
          className="legal-testimonials-grid"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-50px" }}
        >
          {reviews.map((t, i) => (
            <motion.div
              className="legal-testimonial-card"
              key={i}
              variants={itemVariants}
              whileHover={{ y: -8, boxShadow: "0 10px 30px rgba(220, 179, 78, 0.1)" }}
            >
              <div className="legal-testimonial-quote-mark">“</div>
              <div className="legal-testimonial-stars">
                {[...Array(t.stars)].map((_, index) => (
                  <span key={index}>★</span>
                ))}
              </div>
              <p className="legal-testimonial-text">{t.text}</p>
              <div className="legal-testimonial-footer">
                <div className="legal-testimonial-info">
                  <h4 className="legal-testimonial-name">{t.name}</h4>
                  <span className="legal-testimonial-role">{t.role}</span>
                </div>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}

export default Testimonials;